import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '@providers/api/api';

@Injectable()
export class FaskerProvider {
  
    constructor(public api: Api) { }

    addReport(params?:any){
        let seq = this.api.post('index.php/myradiant/Fasker/addreport', params);
        return seq;  
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/fasker/provider.ts